/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// NOTE: This is a stopgap for personalization using the current GCI implementation and will eventually be deprecated.

import React, { useState, useEffect } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {
    string, shape, object, func, bool,
} from 'prop-types';
import mbpLogger from 'mbp-logger';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import { bindActionCreators } from 'redux';
import { getAccessToken } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { setGCIData, clearGCIData, fetchGCIKey } from '../../../../../state/ducks/App/App-Actions';
import { getGCIPersonalizationKey } from '../../../../../state/ducks/App/App-Selectors';
import CelebrationsGreetingCard from '../../../../pages/CGC/CelebrationsGreetingCard';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        border: '1px solid',
        borderRadius: '10px',
        height: '115px',
        padding: theme.spacing(2),
        margin: '0 10px 20px 0',
        [theme.breakpoints.down(900)]: {
            justifyContent: 'center',
        },
    },
    iframe: {
        height: '600px',
        width: '920px',
        borderStyle: 'none',
    },
    buttonContainer: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down(900)]: {
            flexDirection: 'row',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-evenly',
        },
    },
    imageContainer: {
        [theme.breakpoints.down(900)]: {
            display: 'none',
        },
    },
    buttonWrapper: {
        display: 'flex',
    },
    button: {
        margin: '0 10px',
        color: theme.palette.secondary?.main,
        fontFamily: theme.typography.fontFamily,
        backgroundColor: theme.palette.secondary?.['200'],
        height: '30px',
        width: '75px',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    typography: {
        fontWeight: 'bold',
        marginBottom: '5px',
        [theme.breakpoints.down(900)]: {
            margin: 0,
        },
    },
    gciContent: {
        maxWidth: '100vw',
        display: 'flex',
        justifyContent: 'center',
    },
    maxWidth: {
        '& > div > div': {
            maxWidth: '70%',
            minWidth: '1000px',
        },
    },
    customWrapper: {
        minWidth: 80,
        maxWidth: 60,
        maxHeight: 57,
        minHeight: 57,
        borderRadius: 2,
        backgroundSize: 'cover',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    labelType: {
        fontSize: 14,
        margin: 0,
        textAlign: 'center',
    },
    message: {
        fontSize: 14,
        margin: 0,
        marginTop: 2,
    },
}));

const GCIPersonalization = ({
    selectedSku,
    brand,
    actionGetGCIKey,
    actionSetSelectedGCIData,
    actionRemoveGCIData,
    gciKey,
    getUpdatedPersonalizedProdData,
    featureFlags,
}) => {
    const classes = useStyles();
    const [showModal, setModalState] = useState(false);
    const [gciData, updateGCIData] = useState({});
    const  isGciData = gciData?.data;
    const params = {
        productCode: selectedSku?.id,
        brandCode: brand?.id,
        brand: brand?.domain,
    };

    useEffect(() => {
        actionGetGCIKey(params);
    }, []);
    if (!selectedSku?.personalization) { return null; }
    const { personalization: { personalizationDefDesign = '', personalizationTemplate = '' } = {} } = selectedSku;
    const baseUrl = 'https://cardapi.giftcardimpressions.com/800f/physicalcards';
    const url = `${baseUrl}/product/?key_id=${gciKey}&sku=${personalizationDefDesign}&occasion_id=all&brand_name=${brand?.id}&changecard=1&personalization_type=${personalizationTemplate}`;
    const dataListener = () => {
        if (typeof window !== 'undefined') {
            const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
            const eventer = window[eventMethod];
            const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
            eventer(messageEvent, (event) => {
                if (typeof event.data !== 'undefined') {
                    let data = event.data;
                    try {
                        if (typeof event.data === 'string') {
                            data = JSON.parse(event.data);
                            if (data.action === 'personalizationComplete') {
                                const { sku, text, ...personalizationData } = data;

                                const personalization = {
                                    personalizationType: 'PRODUCT_PERSONALIZATION_GCI',
                                    productPersonalization: {
                                        ...personalizationData,
                                        productCode: sku,
                                        brandCode: brand?.id,
                                        // this regex removes all new line characters from string
                                        text: text.replace(/[\n\r]/g, ''),
                                    },
                                };
                                updateGCIData(data);
                                actionSetSelectedGCIData(data);
                                setModalState(false);
                                getUpdatedPersonalizedProdData(personalization);
                            }
                        }
                    } catch (e) {
                        mbpLogger.logError({
                            function: 'GCI',
                            module: 'mbp-pwa-ui',
                            jsError: e,
                            message: 'GCI frame failed',
                        });
                    }
                }
            });
        }
    };

    const setCGCLabelsData = (data) => {
        updateGCIData(data);
        const personalization = {
            personalizationType: 'PRODUCT_PERSONALIZATION_GCI',
            productPersonalization: {
                ...data,
                productCode: personalizationDefDesign,
                brandCode: brand?.id,
            },
        };
        getUpdatedPersonalizedProdData(personalization);
    };
    const removeGCIData = () => {
        updateGCIData({});
        actionRemoveGCIData();
        updateGCIData({});
        getUpdatedPersonalizedProdData({});
    };
    const editCGCLabelData = () => {
        setModalState(true);
    };

    return (
        <>
            <div className={classes.container}>
                <div className={classes.buttonContainer}>
                    {!gciKey
                    && <p className={classes.typography}>Apologies, but we are unable to add personalization at this time.</p>}
                    {gciKey && !gciData?.key_id
                        && (
                            <>
                                <p className={classes.typography}>Personalize this Item? - Only $5.00!</p>
                                <Button data-testid="gci-button-add" className={classes.button} variant="primary" color="primary" onClick={() => { setModalState(true); }}>Yes!</Button>
                            </>
                        )}
                    {gciKey && gciData?.key_id
                        && (
                            <>
                                <p className={classes.typography}>Personalization has been added!</p>
                                <div className={classes.buttonWrapper}>
                                    <Button data-testid="gci-button-remove" className={classes.button} variant="primary" color="primary" onClick={() => { removeGCIData(); }}>Remove</Button>
                                    <Button data-testid="gci-button-remove" className={classes.button} variant="primary" color="primary" onClick={() => { editCGCLabelData(); }}>Edit</Button>
                                </div>
                            </>
                        )}
                </div>
                <div className={classes.imageContainer}>
                    {gciData?.key_id
                        ? (
                            <>
                                <div className={classes.customWrapper} style={{ backgroundImage: `url(${gciData?.data?.cardData})` }}>
                                    <p className={classes.labelType}>
                                        {
                                        isGciData?.message?.text && isGciData?.image
                                            ? 'Photo And Message'
                                            : `${isGciData?.message?.text ? 'Your Message' : 'Your Photo'}`
                                        }
                                    </p>
                                </div>
                                <p className={classes.message}>{gciData?.data?.message ? gciData?.data?.message?.text : ''}</p>
                                <p className={classes.message}>Price: $5.00!</p>
                            </>
                        )
                        : <img src="https://cdn1.thepopcornfactory.com/wcsstore/ThePopcornFactory/images/retro_label.jpg" alt="Personalize your gift with a message, a pic, or both!" />}

                </div>
            </div>
            {
                featureFlags['is-celebration-card-enabled-pdp'] ?                     (
                    <CelebrationsGreetingCard
                        openModal={showModal}
                        closeModal={() => setModalState(false)}
                        isCelebrationsCustomsCard
                        personalizationCustomsType={personalizationDefDesign}
                        orderItemsId={selectedSku?.id}
                        updateCGCCustomsData={setCGCLabelsData}
                        customCardData={gciData}
                    />
                ) : (
                    <Dialog
                        onClose={() => setModalState(false)}
                        open={showModal}
                        fullWidth
                        className={classes.maxWidth}
                        data-testid="personalization-modal"
                    >
                        <IconButton aria-label="Close" className={classes.closeButton} onClick={() => setModalState(false)}>
                            <CloseIcon />
                        </IconButton>
                        <DialogContent className={classes.gciContent}>
                            <iframe
                                onLoad={dataListener()}
                                className={classes.iframe}
                                title="GCIIframe"
                                id="GCIFrame"
                                src={url}
                            />
                        </DialogContent>
                    </Dialog>
                )
            }
        </>
    );
};

GCIPersonalization.propTypes = {
    selectedSku: object.isRequired,
    brand: shape({
        id: string.isRequired,
    }).isRequired,
    actionSetSelectedGCIData: func.isRequired,
    actionRemoveGCIData: func.isRequired,
    actionGetGCIKey: func.isRequired,
    gciKey: string,
    getUpdatedPersonalizedProdData: func.isRequired,
    featureFlags: shape({
        'is-celebration-card-enabled-pdp': bool,
    }).isRequired,
};

GCIPersonalization.defaultProps = {
    gciKey: '',
};

const mapStateToProps = (state) => ({
    jwt: getAccessToken(state),
    gciKey: getGCIPersonalizationKey(state),
});

const mapDispatchToProps = (dispatch) => ({
    actionSetSelectedGCIData: bindActionCreators(setGCIData, dispatch),
    actionRemoveGCIData: bindActionCreators(clearGCIData, dispatch),
    actionGetGCIKey: bindActionCreators(fetchGCIKey, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(GCIPersonalization);
